import { useContext, useEffect, useMemo, useRef, useState } from "react";
import ToastContext from "../../../contexts/toast";
import { RichiestaService } from "../../../services/RichiestaService";
import Select from "../../Form/Select";
import DataTableWrapper from "../../Utility/DataTableWrapper/DataTableWrapper";
import { FormUtility } from "../../Utility/FormUtility";
import { BandoService } from "../../../services/BandoService";
import { tipologieFase } from "../../../constants/TipologiaFase";
import moment from "moment";
import { FaseService } from "../../../services/FaseService";
import { EmailService } from "../../../services/EmailService";

export default function GestioneEmailMassivi() {
  const toastContext = useContext(ToastContext);

  const [avviso, setAvviso] = useState(null);
  const [avvisi, setAvvisi] = useState(null);
  const [tipologiaMassive, setTipologiaMassive] = useState(null);
  const [statoEmail, setStatoEmail] = useState(null);
  const [fase, setFase] = useState(null);
  const [allFasi, setAllFasi] = useState([]);
  const [fasi, setFasi] = useState([]);

  const richiestaService = new RichiestaService();
  const emailService = new EmailService();
  const bandoService = new BandoService();
  const faseService = new FaseService();

  const utility = new FormUtility();

  const [rescheduling, setRescheduling] = useState(false);

  const dtRefEmailMassive = useRef();

  const [tipologieEmailMassive, setTipologieEmailMassive] = useState([
    {id: "EMAIL_APERTURA_FASE_RETTIFICA", label: "Rettifica domande", fasi: [tipologieFase.aggiornamento_isee]},
    {id: "EMAIL_APERTURA_FASE_SECONDO_ACCESSO", label: "Secondo accesso", fasi: [tipologieFase.secondo_accesso_non_ammessi_sospesi]},
    {id: "EMAIL_ESITO_IBAN", label: "Esito IBAN", fasi: [tipologieFase.presentazione_domande, tipologieFase.riapertura_presentazione]},
    {id: "EMAIL_APERTURA_FASE_TERZO_ACCESSO", label: "Terzo accesso", fasi: [tipologieFase.terzo_accesso_sospesi]},
    {id: "EMAIL_MASSIVA_RETTIFICA_IBAN", label: "Rettifica iban", fasi: [tipologieFase.rettifica_iban]},
    {id: "EMAIL_ESITO_ARS", label: "Esito ARS", fasi: [tipologieFase.presentazione_domande, tipologieFase.riapertura_presentazione]},
    {id: "EMAIL_MASSIVA_GRUPPO_REVOCHE", label: "Gruppo Revoche", fasi: []}
  ]);

  const statiEmailMassive = [
    {id:"KO", label: "In errore"},
    {id:"OK", label: "Inviata"},
    {id:"WAITING", label: "In attesa"}
  ]

  useEffect(() => {
    bandoService.getAll().then(res => {
      setAvvisi(res);
    });

    faseService.getAll().then(res => {
      setAllFasi(res.filter(f => [tipologieFase.presentazione_domande, tipologieFase.riapertura_presentazione].includes(f.tipologia)));
    })
  }, []);

  const onChangeTipologiaMassiva = (event) => {
    const value = event.target.value;
    setTipologiaMassive(value ? value : null);
    setFase(null);
    setStatoEmail(null);

    if (!value) {
      return;
    }

    const fasiMassive = tipologieEmailMassive.find(t => t.id === value)?.fasi;
    const fasiFiltrate = allFasi.filter(fase =>
      fasiMassive.includes(fase.tipologia) || fase.fasiAssociate.some(faseAssoc => fasiMassive.includes(faseAssoc.tipologia))
    );
    setFasi([...fasiFiltrate]);
  }

  const onChangeFase = (event) => {
    const value = event.target.value;
    setFase(value ? value : null);
    setStatoEmail(null);

    if (!value) {
      return;
    }

    const phase = allFasi.find(f => f.id === parseInt(value));
    setTipologieEmailMassive(prev =>
      prev.map(item =>
        item.id.startsWith("EMAIL_APERTURA_FASE_RETTIFICA")
          ? {
              ...item,
              id: phase.tipologia === tipologieFase.riapertura_presentazione
                    ? "EMAIL_APERTURA_FASE_RETTIFICA_ISEE_IBAN"
                    : "EMAIL_APERTURA_FASE_RETTIFICA"
            }
          : item
      )
    );

    setTipologiaMassive(
      tipologiaMassive === 'EMAIL_APERTURA_FASE_RETTIFICA'
        ? phase.tipologia === tipologieFase.riapertura_presentazione
            ? 'EMAIL_APERTURA_FASE_RETTIFICA_ISEE_IBAN'
            : 'EMAIL_APERTURA_FASE_RETTIFICA'
        : tipologiaMassive
    );
  }

  const statiEmail = {
    "KO": "in errore",
    "OK": "inviata",
    "WAITING": "in attesa"
  };

  const dtOptions = useMemo(() => {
    if (!(avviso && ((tipologiaMassive !== 'EMAIL_MASSIVA_RETTIFICA_IBAN' && tipologiaMassive!=='EMAIL_MASSIVA_GRUPPO_REVOCHE') ? fase : true) && tipologiaMassive)) return {};

    return {
      columns: [
        {
          name: "Id domanda",
          data: "id",
          visible: true,
          sortable: false,
          searchable: false,
        },
        {
          name: "Id Email",
          data: "idEmail",
          visible: true,
          sortable: false,
          searchable: true,
        },
        {
          name: "Codice pratica",
          data: "codice",
          visible: true,
          sortable: true,
          searchable: true,
        },
        {
          name: "C.F. studente",
          data: "codiceFiscaleBeneficiario",
          visible: true,
          sortable: true,
          searchable: true,
        },
        {
          name: "Email Richiedente",
          data: "email",
          visible: true,
          sortable: true,
          searchable: true,
        },
        {
          name: "Stato email",
          data: "",
          visible: true,
          sortable: true,
          searchable: true,
          cell: (row, col) => {
            if(!row?.esitoEmail) return "";
            return statiEmail[row.esitoEmail] ?? "";
          }
        },
        {
          name: "Errore email",
          data: "erroreEmail",
          visible: true,
          sortable: true,
          searchable: true
        },
        {
          name: "Data invio email",
          data: "emailDataInvio",
          visible: true,
          sortable: true,
          searchable: false,
          cell: (row, col) => {
            if(!row?.emailDataInvio) return "";
            return moment(row.emailDataInvio).format("DD/MM/YYYY HH:mm:ss");
          }
        }
      ],
      serverSide: true,
      ajax: richiestaService.getAllDtMassivo,
      ajaxParams: {
        bandoId: avviso,
        faseId: fase,
        tipologiaEmailMassive: tipologiaMassive,
        esitoEmail: statoEmail
      },
      rows: [],
      sorts: [],
      hideSearch: false,
      title: "Elenco email massive",
    };
  }, [avviso, tipologiaMassive, statoEmail, fase]);

  const rescheduleEmailMassive = () => {
    setRescheduling(true);
    emailService.rescheduleEmailMassive(tipologiaMassive, fase).then((resp) => {
      dtRefEmailMassive.current.rerenderDatatable();
      toastContext.success(resp + ' Email rimesse in scheduling');
      setRescheduling(false);
    }).catch((error) => {
      toastContext.error(utility.getErrorMsg(error), 12000);
      setRescheduling(false);
    });
  };

  return (
    <div className='rtds-container rtds-py-6'>
      <div className='rtds-grid rtds-gap-6 xl:rtds-gap-8'>
        <div className='rtds-flex rtds-items-center rtds-justify-between'>
          <h1 className='rtds-heading-2'>Gestione Email Massive</h1>
        </div>
        <div className='rtds-container rtds-py-6'>
          <div className='rtds-grid rtds-gap-6 xl:rtds-gap-8'>
            <Select
              classDiv={"rtds-mt-0 lg:rtds-mt-0"}
              label={"Avviso"}
              id={"avvisoEmail"}
              classSelect={""}
              onChange={(event) => {
                setAvviso(event.target.value ? event.target.value : null);
                setTipologiaMassive(null);
                setFase(null);
                setStatoEmail(null);
              }}
              baseOption={"Nessuna selezione"}
              bindKey={"id"}
              bindValue={"nome"}
              options={avvisi}
              value={avviso || ""}
            />
            <Select
              classDiv={"rtds-mt-0 lg:rtds-mt-0"}
              label={"Tipologia email massive"}
              id={"tipologiaEmailMassive"}
              classSelect={""}
              onChange={(event) => onChangeTipologiaMassiva(event)}
              baseOption={"Nessuna selezione"}
              bindKey={"id"}
              bindValue={"label"}
              options={tipologieEmailMassive}
              value={tipologiaMassive || ""}
              disabled={!avviso}
            />
            <Select
              classDiv={"rtds-mt-0 lg:rtds-mt-0"}
              label={"Fase"}
              id={"faseEmail"}
              classSelect={""}
              onChange={(event) => onChangeFase(event)}
              baseOption={"Nessuna selezione"}
              bindKey={"id"}
              bindValue={"titolo"}
              options={fasi}
              value={fase || ""}
              disabled={!tipologiaMassive || tipologiaMassive === 'EMAIL_MASSIVA_RETTIFICA_IBAN' || tipologiaMassive ==='EMAIL_MASSIVA_GRUPPO_REVOCHE'}
            />
            <Select
              classDiv={"rtds-mt-0 lg:rtds-mt-0"}
              label={"Stato email"}
              id={"statoEmail"}
              classSelect={""}
              onChange={(event) => {
                setStatoEmail(event.target.value ? event.target.value : null);
              }}
              baseOption={"Nessuna selezione"}
              bindKey={"id"}
              bindValue={"label"}
              options={statiEmailMassive}
              value={statoEmail || ""}
              disabled={!tipologiaMassive}
            />
            <div>
                {avviso && ((tipologiaMassive !== 'EMAIL_MASSIVA_RETTIFICA_IBAN' && tipologiaMassive !== 'EMAIL_MASSIVA_GRUPPO_REVOCHE') ? fase : true) && tipologiaMassive && (
                  <DataTableWrapper
                    ref={dtRefEmailMassive}
                    dtOptions={dtOptions}
                    reloadDatatable={true}
                    headerButton={
                        <button
                        disabled={rescheduling || tipologiaMassive === 'EMAIL_MASSIVA_GRUPPO_REVOCHE'}
                        type="button"
                        className="rtds-btn--secondary rtds-btn rtds-btn--icon-left rtds-btn--s rtds-group/button"
                        onClick={rescheduleEmailMassive}
                        >
                        <svg
                            className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1"
                            aria-hidden="true"
                            focusable="false"
                            role="img"
                        >
                            <use
                            xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--arrow-uturn-right`}
                            />
                        </svg>
                        Riesegui le Email
                        </button>
                    }
                  />
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
